import React from "react";
import { string, oneOfType, shape, object, array } from "prop-types";
import classNames from "classnames/bind";
import { Img } from "../../../Images";
import * as styles from "./SliderSlide.module.scss";

const cx = classNames.bind(styles);

const SliderSlide = ({ image }) => (
	<Img
		className={cx("img")}
		wrapperClassName={cx("img")}
		src={image?.src}
		source={image?.source}
		fixed={image?.fixed}
		fluid={image?.fluid}
		alt={image?.alt}
		title={image?.title}
	/>
);

SliderSlide.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		title: string,
		alt: string.isRequired,
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		src: string,
	}).isRequired,
};

export default SliderSlide;
export { SliderSlide };
